import { render } from "./Streams.vue?vue&type=template&id=153578c2&scoped=true&bindings={\"config\":\"setup\",\"streamsLoading\":\"setup\",\"sortedStreams\":\"setup\",\"filteredStreams\":\"setup\",\"responsiveClass\":\"setup\",\"infoWidth\":\"setup\",\"titles\":\"setup\",\"toggleConfigKey\":\"setup\"}"
import script from "./Streams.vue?vue&type=script&lang=js"
export * from "./Streams.vue?vue&type=script&lang=js"

import "./Streams.vue?vue&type=style&index=0&id=153578c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-153578c2"

export default script